import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React from "react";

import { widthXS } from "../theme";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		backgroundColor: theme.palette.primary.ERVBlue,
		maxWidth: "100%",
		minHeight: 96,
		[theme.breakpoints.down(widthXS)]: {
			minHeight: 56,
		},
	},
	container: {
		display: "flex",
		justifyContent: "flex-start",
		alignItems: "center",
		maxWidth: 1180,
	},
	text: {
		color: theme.palette.primary.White,
		fontFamily: theme.palette.primary.fontW1G,
		fontSize: "1.875rem",
		fontWeight: 400,
		[theme.breakpoints.down(widthXS)]: {
			fontSize: "1.125rem",
		},
	},
	sub: {
		color: theme.palette.primary.White,
		fontFamily: theme.palette.primary.fontW1G,
		fontSize: "0.8125rem",
		fontWeight: 400,
		[theme.breakpoints.down(widthXS)]: {
			fontSize: "0.6875rem",
		},
	},
}));

function TitleBar({ title, subTitle }) {
	const classes = useStyles();

	return (
		<Container className={classes.root}>
			<Grid container direction="row" className={classes.container}>
				<Grid item xs={12}>
					<Typography className={classes.text} variant="h1">
						{title}
					</Typography>
				</Grid>
				<Grid item xs={12}>
					<div className={classes.sub}>{subTitle}</div>
				</Grid>
			</Grid>
		</Container>
	);
}

export default TitleBar;
